import { DashboardWrapper } from "container/dashboard-wrapper";

const Home = () => {
   return <DashboardWrapper>Admin</DashboardWrapper>;
};

export default Home;
